<div class="box">
  <form #osakkaatForm="ngForm">
    @if (onkoVirhe(lomake.osakkaat, 'min')) {
      <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-osakas' | translate | async }}</div>
    }

    <div class="top-info">
      @if (isDataFromKyc()) {
        <div style="margin-bottom: 5px">Osakkaat haettiin tuntemistietojen uusimmasta versiosta (tallennettu {{ tuntemistiedotTallennettu() }}).</div>
      }
      <div style="font-size: 11px">Huom! Nämä tiedot tallennetaan vain veroilmoitukselle. Tämän lomakkeen tiedot eivät vaikuta asiakkaan tuntemistietoihin millään tavalla.</div>
    </div>

    <div>
      @for (rivi of lomake.osakkaat; track rivi; let i = $index) {
        <div class="kyc-row">
          <mat-form-field class="kyc-col">
            <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
            <input type="text" [formField]="rivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
            <mat-error>
              @if (rivi.nimi; as n) {
                @if (n().touched() || osakkaatForm.submitted) {
                  @if (onkoVirhe(n, 'required')) {
                    {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                  }
                }
              }
            </mat-error>
          </mat-form-field>
          <mat-form-field class="kyc-col">
            <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus' | translate | async }}</mat-label>
            <input type="text" [formField]="rivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
            <mat-error>
              @if (rivi.hetu; as n) {
                @if (n().touched() || osakkaatForm.submitted) {
                  @if (onkoVirhe(n, 'required')) {
                    {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-required' | translate | async }}
                  }
                  @if (onkoVirhe(n, 'invalid')) {
                    {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-invalid' | translate | async }}
                  }
                  @if (onkoVirhe(n, 'ownytunnus')) {
                    {{ 'lemonaid-sopimus-dialog.kyc.oma-ytunnus' | translate | async }}
                  }
                }
              }
            </mat-error>
          </mat-form-field>
          <mat-form-field class="kyc-col">
            <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara' | translate | async }}</mat-label>
            <input decimalNumberField matInput [formField]="rivi.osakkeita" [numberOfDecimals]="0" autocomplete="nothing" data-lpignore="true" />
            <mat-error>
              @if (rivi.osakkeita; as n) {
                @if (n().touched() || osakkaatForm.submitted) {
                  @if (onkoVirhe(n, 'required')) {
                    {{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara-puuttuu' | translate | async }}
                  }
                }
              }
            </mat-error>
          </mat-form-field>
          <app-icon-button (click)="poistaOsakas(i); $event.preventDefault()" actionId="Poista osakas (veroilmoitus)" matIcon="delete"> </app-icon-button>
        </div>
      }
    </div>

    <app-secondary-button (click)="lisaaOsakas(); $event.preventDefault()" actionId="Lisää osakas (veroilmoitus)" additionalClass="kyc-lisaa"> Lisää osakas </app-secondary-button>

    <!-- <button class="primarybutton kyc-lisaa" mat-button (click)="tallenna(); $event.preventDefault();">
    Tallenna
  </button> -->

    @if (commonError) {
      <div class="lemon-error">{{ commonError }}</div>
    }
  </form>
</div>
